// extracted by mini-css-extract-plugin
module.exports = {"addButton":"styles_addButton__1RO2-","newColumnButtons":"styles_newColumnButtons__20W8x"};